var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"switch-btn-box"},[_c('div',{staticClass:"sider-switch-btn left-[358px] top-[248px]",on:{"click":_vm.showSiderbar}},[_c('div',{staticClass:"open-btn"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }